<template>
  <b-card header-tag="header" footer-tag="footer" class="shadow w-md-50">

    <!-- Modals -->
    <ClientAddModal id="addClientModal" @ok="getAllClients"></ClientAddModal>

    <template v-slot:header>
      <h6 class="m-0 font-weight-bold text-site-primary">Clients</h6>
    </template>

    <!-- Controls -->
    <b-card-text>
      <b-card-group class="children-mr-2">
        <b-button v-b-modal.addClientModal variant="primary" size="sm" class="bg-site-primary">Add Client</b-button>
      </b-card-group>
    </b-card-text>

    <b-card-text>
      <b-table
        hover
        :items="clientList"
        primary-key="id"
        @row-clicked="showClient"
        tbody-tr-class="cursor-pointer"
        :fields="[
          {
            key: 'id',
            label: 'ID',
            sortable: true
          },
          {
            key: 'username',
            label: 'Name',
            sortable: true
          },
        ]"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            @click="showClient(row.item, row.index, $event.target)"
            class="mr-1"
          >Edit</b-button>
        </template>
      </b-table>
    </b-card-text>
  </b-card>
</template>

<script>
import ClientAddModal from "./ClientAddModal";
export default {
  name: `ClientList`,
  components: {
    ClientAddModal,
  },
  data() {
    return {
      clientList: null,
      selectedClient: null,
    };
  },
  mounted() {
    this.getAllClients();
  },
  methods: {
    getAllClients() {
      this.$store
        .dispatch("client/getAllSimple")
        .then((data) => (this.clientList = data));
    },
    showClient(row) {
      this.$router.push({ path: `/admin/clients/${row.id}` });
      // this.$root.$emit("bv::show::modal", `editClientModal`, button);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>